import { useLanguage } from '../i18n/LanguageContext';
import type { ShareCardAvatarMode } from '../utils/shareCardHelpers';

export interface QuizShareAvatarPickerProps {
  value: ShareCardAvatarMode;
  onChange: (mode: ShareCardAvatarMode) => void;
  personalPreviewUrl: string;
  defaultEmoji: string;
  tone?: 'gold' | 'ice';
}

const OPTIONS: ShareCardAvatarMode[] = ['personal', 'default'];

export default function QuizShareAvatarPicker({
  value,
  onChange,
  personalPreviewUrl,
  defaultEmoji,
  tone = 'gold',
}: QuizShareAvatarPickerProps) {
  const { m } = useLanguage();
  const labels = m.share.avatarPicker;

  return (
    <div className={`quiz-share-avatar-picker quiz-share-avatar-picker--${tone}`}>
      <span className="quiz-share-avatar-label">{labels.label}</span>
      <div className="quiz-share-avatar-options" role="radiogroup" aria-label={labels.ariaLabel}>
        {OPTIONS.map((mode) => {
          const selected = value === mode;
          const optionLabels = labels[mode];
          return (
            <button
              key={mode}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`quiz-share-avatar-btn${selected ? ' quiz-share-avatar-btn--active' : ''}`}
              onClick={() => onChange(mode)}
            >
              <span className="quiz-share-avatar-btn-preview" aria-hidden>
                {mode === 'personal' ? (
                  <img src={personalPreviewUrl} alt="" />
                ) : (
                  <span className="quiz-share-avatar-btn-emoji">{defaultEmoji}</span>
                )}
              </span>
              <span className="quiz-share-avatar-btn-title">{optionLabels.title}</span>
              <span className="quiz-share-avatar-btn-desc">{optionLabels.description}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}